import React from "react";
import { connect } from "react-redux";

import CreateLink from "../../components/createLink/index";
import MainContainer from "../../components/mainContainer/index";

import MobileDetect from "mobile-detect";

import style from "./style.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faNewspaper,
    faInfoCircle,
    faThumbtack
} from "@fortawesome/free-solid-svg-icons";

// Lista de noticias del feed. Orden de render: pinned primero, después
// fecha desc (más recientes arriba). Para agregar más posts, sumá objetos
// al array — el `pinned: true` lo fija arriba; sin él, va por fecha.
// Cada noticia podría también vivir en un endpoint de API a futuro.
const NEWS_FEED = [
    {
        id: 1,
        date: "2026-05-25",
        pinned: true,
        title: "¡Bienvenidos a Argentum Online Web!",
        image: "/static/imgs/bg1.png",
        body: (
            <>
                <p>
                    <strong>Iniciá sesión</strong> o creá una cuenta gratis
                    desde el navbar para poder jugar.
                </p>
                <p>
                    <strong>Nos comprometemos</strong> a que ningún personaje
                    creado en este servidor sea borrado nunca. Sin wipes
                    sorpresa, sin resets. Lo que conseguís jugando, queda.
                </p>
                <p>
                    El <strong>nivel máximo</strong> actual es <strong>42</strong>.
                    Cuando estabilicemos el endgame lo iremos ampliando con
                    contenido balanceado a cada tramo.
                </p>
            </>
        )
    },
    {
        id: 8,
        date: "2026-05-27",
        title: "Tu hogar, donde quieras",
        body: (
            <>
                <p>
                    Ahora podés <strong>fijar tu hogar en cualquier ciudad</strong>{" "}
                    del mundo. Hacé <strong>click derecho</strong> sobre el
                    Gobernador de la aldea en la que estés parado y elegí{" "}
                    <strong>Hogar</strong>. La próxima vez que uses <code>/hogar</code>,
                    vas a aparecer ahí.
                </p>
                <p>
                    Gobernadores disponibles en{" "}
                    <strong>Ullathorpe, Nix, Banderbill, Lindos y Arghal</strong>.
                </p>
            </>
        )
    },
    {
        id: 9,
        date: "2026-05-27",
        title: "Brujas y Medusas ahora castean hechizos",
        body: (
            <>
                <p>
                    Primer iteración de IA mágica para enemigos PvE. Las{" "}
                    <strong>Brujas</strong> te tiran <strong>Inmovilizar</strong>{" "}
                    cada 10 segundos — quedás clavado al piso pero podés
                    atacar y castear.
                </p>
                <p>
                    Las <strong>Medusas</strong> son peores: <strong>Paralizar</strong>{" "}
                    cada 7 segundos. Lock total — no te movés, no atacás, no
                    casteás. Hacé pareja antes de buscarlas.
                </p>
                <p>
                    Si tu personaje quedó congelado o paralizado, prepará{" "}
                    <strong>Remover Paralisis</strong> antes de los dungeons.
                </p>
            </>
        )
    },
    {
        id: 2,
        date: "2026-05-25",
        title: "25 de Mayo · Apertura oficial",
        body: (
            <p>
                Hoy, <strong>día de la patria</strong>, abrimos las puertas
                del primer port web 100% jugable del Argentum clásico. Sin
                descargas, sin launcher, sin parches — una URL y estás
                adentro.
            </p>
        )
    },
    {
        id: 3,
        date: "2026-05-25",
        title: "Banco habilitado en Ullathorpe",
        body: (
            <>
                <p>
                    Ya podés depositar y retirar items del Banquero (Ullathorpe).
                    <strong> 24 slots</strong> de almacenamiento, drag-and-drop
                    entre inventario y banco, deposit/withdraw parcial con cantidad
                    seleccionable.
                </p>
                <p>
                    Tip: items <strong>equipados</strong> aparecen con la "E" en
                    el banco — no se pueden depositar mientras los uses.
                </p>
            </>
        )
    },
    {
        id: 4,
        date: "2026-05-25",
        title: "NPCs hostiles más inteligentes",
        body: (
            <>
                <p>
                    Los NPCs enemigos ahora <strong>sortean obstáculos</strong>{" "}
                    para llegar a vos. Antes se quedaban trabados en un árbol y
                    el combate era trivial; ahora calculan ruta cuando hace falta.
                </p>
                <p>
                    Combate también mejorado: sonidos de <strong>bloqueo de
                    escudo</strong>, <strong>falla</strong> y <strong>impacto
                    recibido</strong> con feedback claro de qué pasa cada tick.
                </p>
            </>
        )
    },
    {
        id: 5,
        date: "2026-05-21",
        title: "Sistema de audio habilitado",
        body: (
            <>
                <p>
                    Ahora el juego tiene <strong>música ambiental</strong> en
                    loop y <strong>efectos de sonido</strong> (combate, hechizos,
                    pasos, NPCs, level up, etc.).
                </p>
                <p>
                    Configurá volumen y on/off desde el ícono ⚙ dentro del
                    juego — Música, Ambiente y Efectos por separado.
                </p>
            </>
        )
    },
    {
        id: 6,
        date: "2026-05-21",
        title: "UI modernizada",
        body: (
            <>
                <p>
                    El HUD del juego fue rediseñado completamente: cajas
                    independientes para chat, macros, stats y mapa con look
                    consistente.
                </p>
                <p>
                    Viewport del juego ahora muestra <strong>21×21 tiles</strong>{" "}
                    (antes 17×17) para mejor visión del campo de batalla.
                </p>
            </>
        )
    },
    {
        id: 7,
        date: "2026-05-21",
        title: "Próximamente",
        body: (
            <p>
                Profesiones jugables (minería, pesca, leñador), sistema de
                veneno y antídoto, invocaciones para Druidas, casas con llaves,
                expansión del nivel máximo más allá de 42 y mucho más. Estate
                atento al feed.
            </p>
        )
    }
];

// Sort: pinned primero (orden estable entre ellos), después fecha desc.
const sortedNews = [...NEWS_FEED].sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return b.date.localeCompare(a.date);
});

class Home extends React.Component {
    static async getInitialProps({ req }) {
        const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
        return { userAgent };
    }

    render() {
        const { userAgent } = this.props;
        const md = new MobileDetect(userAgent);
        const isMobile = md.mobile();

        return (
            <MainContainer userAgent={userAgent}>
                <div className={style.feed}>
                    <div className={style.feedHeader}>
                        <FontAwesomeIcon icon={faNewspaper} />
                        <h2>Noticias</h2>
                        <span className={style.feedCount}>
                            {sortedNews.length}
                        </span>
                    </div>

                    <div className={style.feedList}>
                        {sortedNews.map(post => (
                            <article
                                key={post.id}
                                className={`${style.post} ${post.pinned ? style.postPinned : ""}`}
                            >
                                {post.image && !isMobile && (
                                    <div
                                        className={style.postImage}
                                        style={{
                                            backgroundImage: `url('${post.image}')`
                                        }}
                                        role="img"
                                        aria-label={post.title}
                                    />
                                )}
                                <div className={style.postBody}>
                                    <div className={style.postMeta}>
                                        {post.pinned ? (
                                            <span className={style.pinnedBadge}>
                                                <FontAwesomeIcon icon={faThumbtack} />
                                                <span>Fijado</span>
                                            </span>
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={faInfoCircle}
                                                className={style.postIcon}
                                            />
                                        )}
                                        <time className={style.postDate}>
                                            {post.date}
                                        </time>
                                    </div>
                                    <h3 className={style.postTitle}>
                                        {post.title}
                                    </h3>
                                    <div className={style.postContent}>
                                        {post.body}
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>

                </div>
            </MainContainer>
        );
    }
}

export default connect()(Home);
